'use client';
import { MultiServicePreset } from '@/types';

import Image from 'next/image';
import { useConfig } from '@/app/contexts/ConfigContext';
import { SERVICE_TYPES } from '@/helpers/enums';
import { URL_S3 } from '@/helpers/constants';
import { TextNumber } from '@/types';

interface HeroProps {
  textNumber: TextNumber;
}

export default function Hero({ textNumber }: HeroProps) {
  const { wording, config } = useConfig();

  const heroKey = `page_${textNumber}_hero_text` as keyof typeof wording;
  const heroServiceType = (() => {
    if (config.multiService !== MultiServicePreset.AML) {
      return config.serviceType;
    }

    if (textNumber === 'text2') {
      return SERVICE_TYPES.ASTROLOGY;
    }

    if (
      textNumber === 'text1' &&
      config.serviceType !== SERVICE_TYPES.MEDITATION
    ) {
      return SERVICE_TYPES.MEDITATION;
    }

    return config.serviceType;
  })();

  return (
    <div className='relative sm:max-w-[1710px] max-w-[390px] mx-auto'>
      <Image
        className='hidden sm:block relative'
        height={496}
        width={1715}
        src={`${URL_S3}/${heroServiceType}/images/${textNumber}-hero.webp`}
        alt='hero'
        priority
      />
      <Image
        height={173}
        width={390}
        className='block sm:hidden relative'
        src={`${URL_S3}/${heroServiceType}/images/${textNumber}-hero-mobile.webp`}
        alt='hero'
        priority
      />
      <div className='absolute left-0 top-0 flex items-center justify-center h-full w-full'>
        <span
          className='text-white sm:text-[80px] text-[32px] font-extrabold sm:leading-[88px] leading-9 text-center'
          style={{ color: config.theme.textColorLight }}
        >
          {wording?.[heroKey]}
        </span>
      </div>
    </div>
  );
}
